import { useEffect } from 'react';

/**
 * Execute callback whenever the browser tab or window changes from unfocused to focused.
 */
export const useVisibilityChange = (callback: Function) => {
    useEffect(() => {
        const onVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                callback();
            }
        };

        document.addEventListener('visibilitychange', onVisibilityChange);

        return () => {
            document.removeEventListener('visibilityChange', onVisibilityChange);
        };
    }, []);
};
